import React, { useState, useEffect } from "react";
import SimpleOptionSelector from "./SimpleOptionSelector";

const FontSizeSelector = ({ selected, classGroups, handleGroupChange, groupKeys }) => {
  const [activeMode, setActiveMode] = useState("default");

  const availableModes = Object.keys(classGroups?.font_size?.options || {});

  // Determine current mode based on selected class
  const detectModeFromClass = (className) => {
    if (!className) return "default";

    // Find the mode by checking which options contain this class
    for (const mode of availableModes) {
      const options = classGroups.font_size.options[mode];
      if (options && options.some((option) => option.class === className)) {
        return mode;
      }
    }
    return "default";
  };

  // Determine initial mode based on current selection
  useEffect(() => {
    const detectedMode = detectModeFromClass(selected.font_size);
    setActiveMode(detectedMode);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected.font_size]);

  const handleModeToggle = (targetMode) => {
    const newMode = activeMode === targetMode ? "default" : targetMode;
    setActiveMode(newMode);

    const oldOptions = classGroups.font_size.options[activeMode];
    const selectedIndex = oldOptions?.findIndex((opt) => opt.class === selected.font_size);

    if (selectedIndex != null && selectedIndex >= 0) {
      const newOptions = classGroups.font_size.options[newMode];
      const mappedClass = newOptions?.[selectedIndex]?.class;
      if (mappedClass) {
        handleGroupChange("font_size", mappedClass);
      }
    }
  };

  const renderLabel = (cls) => {
    const label = cls.split("-").pop();
    return label ? <span className={`z-font-${label.slice(1)}`}>{label.toUpperCase()}</span> : "?";
  };

  if (!groupKeys.includes("font_size") || !classGroups.font_size) {
    return null;
  }

  const currentOptions = classGroups.font_size.options[activeMode] || classGroups.font_size.options.default;

  const ToggleButtons = () => {
    return (
      <>
        {availableModes
          .filter((mode) => mode !== "default")
          .map((mode) => {
            const isActive = activeMode === mode;

            return (
              <div
                key={mode}
                onClick={() => handleModeToggle(mode)}
                className="px_1 py_0 border_radius_small font_weight_medium cursor_pointer"
                style={{
                  fontSize: "10px",
                  transition: "all 0.2s ease-in-out",
                  userSelect: "none",
                  border: "1px solid",
                  borderColor: isActive ? "#3b82f6" : "#e5e7eb",
                  background: isActive ? "#3b82f6" : "#ffffff",
                  color: isActive ? "#ffffff" : "#6b7280",
                  marginLeft: mode !== availableModes.filter((m) => m !== "default")[0] ? "8px" : "0"
                }}
              >
                {mode}
              </div>
            );
          })}
      </>
    );
  };

  return (
    <div>
      <SimpleOptionSelector
        label="Font Size"
        options={currentOptions}
        selectedClass={selected.font_size}
        onChange={(cls) => handleGroupChange("font_size", cls)}
        renderLabel={renderLabel}
        boxStyle={{ fontWeight: "500" }}
        applyClass={activeMode === "default"}
        advancedStylesNode={<ToggleButtons />}
      />
    </div>
  );
};

export default FontSizeSelector;
